<template>
    <div class="panel panel-flat">
        <div class="panel-heading">
            <h5>{{transEdit('occupancy-rate')}}</h5>
        </div>
        <div class="panel-body">
            <div class="row">
                <div class="col-md-6">
                    <admin-dash-occupancy-graph :occupancy="occupancy">
                    </admin-dash-occupancy-graph>
                </div>
                <div class="col-md-6">
                    <admin-dash-bookings-graph :occupancy="occupancy">
                    </admin-dash-bookings-graph>
                </div>
            </div>

            <!--<div class="row mt-4">

                <div class="col-md-12">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Datum</th>
                                <th class="text-right">Schemalagda tider</th>
                                <th class="text-right">Bokningar</th>
                                <th class="text-right">Beläggningsgrad</th>
                                <th></th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="day in occupancy">
                                <td>{{day.date}}</td>
                                <td class="text-right">{{day.schedules}} st</td>
                                <td class="text-right">{{day.bookings}} st</td>
                                <td class="text-right">{{Math.round(day.occupancyrate * 10) /10}} %</td>
                                <td> </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>-->
        </div>
        <hr>
    </div>
</template>

<script>
    export default {
        props: ['part'],
        data: function () {
            return {
                occupancy: [],
            };
        },
        name: "admin-dash-occupancy",
        mounted () {
            let self = this;
            axios.get(this.part.route_refresh)
            .then(function (response) {
                self.occupancy = response.data.occupancy;
            })
            .catch(function (error) {
            });
        }
    }
</script>

<style scoped>

</style>
